import React, { Fragment } from 'react';
import { isMobile, isIOS } from 'react-device-detect';
import { isNil } from 'lodash';

/**
 * @desc Check if device is `mobile` and platform is `iOS-browser`.
 * @example
 * import { isIosWeb } from 'core/modules/device-detect';
 */
export const isIosWeb = () => {
	return isMobile && isIOS && isNil( window.device );
};

/**
 * @desc Render children if device is `mobile` and platform is `iOS-browser`.
 * @example
 * import { ForIosWeb } from 'core/modules/device-detect';
 */
export const ForIosWeb = ( props ) => {
	if( isIosWeb() ) {
		return (
			<Fragment>
				{ props.children }
			</Fragment>
		);
	} else {
		return null;
	}
};
